import { formHelperTextClasses } from '@mui/material';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers';
import { Dayjs } from 'dayjs';

type Props = DatePickerProps<Dayjs> & {
  dateError?: boolean;
};

export default function FilterDatePicker({ dateError, ...props }: Props) {
  return (
    <DatePicker
      format="DD/MM/YYYY"
      slotProps={{
        textField: {
          fullWidth: true,
          error: dateError,
          helperText: dateError && 'ช่วงวันที่ไม่ถูกต้อง',
        },
        field: {
          readOnly: true,
        },
      }}
      sx={{
        maxWidth: { md: 180 },
        [`& .${formHelperTextClasses.root}`]: {
          position: { md: 'absolute' },
          bottom: { md: -40 },
        },
      }}
      {...props}
    />
  );
}
